// We need an additional hour of stock levels data to display material orders correctly
export const STOCK_DEVELOPMENT_END_HOURS_PADDING = 2
